// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"4303efdd","270":"0a09c7c6","378":"03d802b8","453":"2fb2dfa7","569":"6763ed52","652":"24126b29","787":"0a39258d"}[chunkId] + ".chunk.js";
};